import mitt from 'mitt';

import type {
  ActivationProcessingComplete,
  CreateSchoolForNewLearnerProcessingComplete,
  JoinClassAsLearnerProcessComplete,
  ActivationProcessingEventRecieved,
  JoinClassAsTeacherProcessComplete,
  JoinSchoolProcessComplete,
  ClassMaterialAssociationProcessComplete,
  CertificateGenerationComplete
} from '@c1/dashboard.types.server-push-events';

type ApplicationEvents = {
  'user:activation-processing-complete': ActivationProcessingComplete;
  'learner:join-class-process-complete': JoinClassAsLearnerProcessComplete;
  'teacher:join-class-process-complete': JoinClassAsTeacherProcessComplete;
  'user:create-school-for-new-learner-process-complete': CreateSchoolForNewLearnerProcessingComplete;
  'user:desktop-app-banner-visible': boolean;
  'user:activation-processing-event-recieved': ActivationProcessingEventRecieved;
  'user:join-school-process-complete': JoinSchoolProcessComplete;
  'user:class-materials-association-process-complete': ClassMaterialAssociationProcessComplete;
  'teacher:certificate-generation-complete': CertificateGenerationComplete;
};

export default defineNuxtPlugin(() => {
  // Then we just inform mitt about our event types
  const emitter = mitt<ApplicationEvents>();

  return {
    provide: {
      event: emitter.emit, // Will emit an event
      listen: emitter.on, // Will register a listener for an event
      removeListen: emitter.off // Will remove a listener for an event
    }
  };
});
